import { Link, Image } from '@utils/cook/types'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import RelatedEntitiesComponent from '@components/RelatedEntities'
import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'

interface EntityProps {
  image?: Image<'free'>
  title: string
  link: Link
}

export interface RelatedEntitiesProps {
  title?: string
  hideOnDesktop?: boolean
  items: EntityProps[]
}

const RelatedEntities: FunctionComponent<RelatedEntitiesProps> = (props) => {
  const { isRelatedEntitiesEnabled } = useFeatureFlagsSkeleton()
  if (!isRelatedEntitiesEnabled) {
    return null
  }

  if (!props.items || props.items.length === 0) {
    return null
  }
  return <RelatedEntitiesComponent {...props} />
}

const widget = {
  kind: ['related-entities'],
  component: RelatedEntities,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
